$(document).ready(function () {
  $('.value img').removeAttr('width');

  //   $(window).scroll(function() {
  //     if ($(window).scrollTop() > 100) {
  //       $('.spr-reviews').addClass('js-product-slider');
  //       if(window.innerWidth < 767)
  //       {
  //         $('.js-product-slider').slick(
  //           {
  //             dots: true
  //           }
  //         );
  //       }
  //     }
  //   });

  $("h1.product-info__title:contains('®') , p.product-info__vendor:contains('®')").each(function () {
    $(this).html($(this).html().replace("®", "<sub>®</sub>"));
  });

});

$(document).ready(function () {
  $('.smooth-scroll').click(function (e) {
    e.preventDefault();
    var target = $($(this).attr('href'));
    var body = $($('.product-description__accordion-header.content').attr('aria-hidden', false));
    if (target.length) {
      var scrollTo = target.offset().top;
      var bodyscroll = body.offset().top;
      $('body, html').animate({ scrollTop: bodyscroll }, 1000);
    }
  });
});
$(document).ready(function () {
  var $window = $(window);
  var $productinfo = $(".scroll-info");
  var $productinfoHeight = $productinfo.innerHeight();
  var $productimagesOffsetTop = $(".custom-fields-section").offset();
  var $sidebarOffset = $productinfo.offset();

  $window.scroll(function () {
    if ($window.scrollTop() > $sidebarOffset) {
      $productinfo.css("position", "sticky");
    } else {
      $productinfo.css("position", "sticky");
    }
    if ($window.scrollTop() + $productinfoHeight > $productimagesOffsetTop) {
      $productinfo.css({ "top": -($window.scrollTop() + $productinfoHeight - $productimagesOffsetTop) });
    } else {
      $productinfo.css({ "top": "125px", });
    }
  });

});

$(document).ready(function () {
  $(" .row-title button p ").click(function () {
    if ($(this).hasClass("active")) {
      $("button p").removeClass('active');
    } else {
      $("button p").removeClass('active');
      $(this).addClass('active');
    }
  });

});

$(window).load(function () {
  if (window.location.href.indexOf("#reviews") > -1) {
    event.preventDefault();
    var review_scroll = $('#shopify-section-product-reviews').offset().top;
    $('html, body').animate({ scrollTop: review_scroll - 115 }, 1000);
  }
});




// START - PDP Sticky Add to Cart
$(document).ready(function () {
  let atcObserver;

  function initStickyATC() {
    const atcButton = document.querySelector('.product-form__cart-submit');
    if (!atcButton) return;

    if (atcObserver) atcObserver.disconnect();

    atcObserver = new IntersectionObserver(
      ([entry]) => {
        const isAboveViewport = entry.boundingClientRect.top < 0 && !entry.isIntersecting;

        if (isAboveViewport) {
          document.body.classList.add('visible--sticky-atc');
        } else {
          document.body.classList.remove('visible--sticky-atc');
        }
      },
      {
        root: null,
        threshold: 0,
      }
    );

    atcObserver.observe(atcButton);
  }

  // Init on page load
  initStickyATC();

  document.addEventListener('rebuy:smartcart.hide', (event) => {
    // const smartcart = event.detail.smartcart;
    // console.log('rebuy:smartcart.hide: smartcart', smartcart);

    setTimeout(() => {
      if (window.scrollY === 0) {
        document.body.classList.remove('visible--sticky-atc');
      } else {
        document.body.classList.remove('visible--sticky-atc');
        window.scrollTo({
          top: 0
        });
      }
    }, 200);
  });

  $('.sticky-atc__button').on('click', function (e) {
    e.preventDefault();
    $('.product-form__cart-submit').trigger('click');
  });
});






// END - PDP Sticky Add to Bag
